import React from "react";
import activities from "../assets/images/activities.png";
import leftarrow from "../assets/images/arrow-left.png";

function VedioDone(props) {
  return (
    <>
      <body>
        <section className="vedio_section">
          <a className="" href="" data-toggle="modal" data-target="#feadback">
            <img
              src={activities}
              className="share_icon"
              style={{ width: 200, height: 150 }}
            />
          </a>
          <div className="vedio_record">
            <img src={leftarrow} alt="" />
          </div>
        </section>

        <div
          className="modal fade starrating"
          id="feadback"
          data-backdrop="static"
          data-keyboard="false"
          tabindex="-1"
          aria-labelledby="feadbackLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="feadbackLabel">
                  Share video
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  {" "}
                  <span aria-hidden="true">&times;</span>{" "}
                </button>
              </div>
              <div className="modal-body social_text">
                {/*   <p>
                  Lorem ipsum dolor sit amet, consectetur acing elit. nun c non
                  risus condiment lobortittyr at ef sollicitu.
                </p> */}
                <ul className="social_icon">
                  <li>
                    <a href="">
                      <img src="assets/images/linke.png" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="assets/images/twitter.png" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="assets/images/instta.png" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="assets/images/facebook.png" />
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="assets/images/whattsapp.png" />{" "}
                    </a>
                  </li>
                  <li>
                    <a href="">
                      <img src="assets/images/tiktok.png" />
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </body>
    </>
  );
}

export default VedioDone;
